import React from 'react'
import { TRADE_TYPE } from '@components/ExperienceShop/constant'
import { dGet } from '@core/utils'

const columns = [
  {
    title: '交易时间',
    dataIndex: 'tradeTime',
    render: tradeTime => {
      if (!tradeTime.split) {
        return tradeTime
      }

      const [ymd, hms] = tradeTime.split(' ')
      return (
        <>
          <div>{ymd}</div>
          <div>{hms}</div>
        </>
      )
    }
  },
  {
    title: '流水号',
    dataIndex: 'tradeNo'
  },
  {
    title: '支付单号',
    dataIndex: ['brokerageOrder', 'billNo']
  },
  {
    title: '合作订单号',
    dataIndex: ['cooperateOrder', 'orderNo']
  },
  {
    title: '关联用户订单',
    dataIndex: ['cooperateOrder', 'orderSub', 'parentOrderNo']
  },
  {
    title: '用户/手机号',
    dataIndex: 'user_info',
    render: (o, { cooperateOrder }) => {
      const { userName, userPhone } = cooperateOrder
      return (
        <>
          <div>{userName}</div>
          <div>{userPhone}</div>
        </>
      )
    }
  },
  {
    title: '订单金额',
    dataIndex: ['cooperateOrder', 'totalMoney']
  },
  {
    title: '服务费金额',
    dataIndex: 'changeMoney'
  },
  {
    title: '类型',
    dataIndex: 'type',
    render: type => {
      return TRADE_TYPE[String(type)]
    }
  },
  {
    title: '操作统筹师',
    dataIndex: ['brokerageOrder', 'merchantSupport', 'nick'],
    render: (o, { brokerageOrder }) => {
      const refundNick = dGet(brokerageOrder, 'refundMerchantSupport.nick')
      return (
        <div>
          {refundNick
            ? refundNick
            : dGet(brokerageOrder, 'merchantSupport.nick')}
        </div>
      )
    }
  },
  {
    title: '合作体验店',
    dataIndex: ['cooperateOrder', 'experienceMerchant', 'name']
  }
]

columns.forEach(item => {
  item.width = 120
})

export default columns
